gsap.registerPlugin(ScrollTrigger);


/**
 *计算元素的初始平移和 3D 旋转，将其移动和旋转到远离屏幕中心的位置。
 *旋转和 Z 轴平移与距中心的距离成正比，靠近中心的元素旋转较少，Z 轴移动较少。
 *
 *@param {Element} 元素 -用于计算平移和旋转的 DOM 元素
*@param {Number} offsetDistance -元素远离中心的距离（默认值：250px）
 *@param {Number} maxRotation -最远元素的最大旋转角度（默认值：300 度）
 *@param {Number} maxZTranslation -最远元素的最大 Z 轴平移（以像素为单位）（默认值：2000px）
 *@returns {Object} x、y、z 平移和rotateX、rotateY 值为{x、y、z、rotateX、rotateY}
 */
const calculateInitialTransform = (element, offsetDistance = 250, maxRotation = 300, maxZTranslation = 2000) => {
  const viewportCenter = { width: window.innerWidth / 2, height: window.innerHeight / 2 };
  const elementCenter = {
    x: element.offsetLeft + element.offsetWidth / 2,
    y: element.offsetTop + element.offsetHeight / 2
  };

  //计算元素中心与视口中心之间的角度
  const angle = Math.atan2(Math.abs(viewportCenter.height - elementCenter.y), Math.abs(viewportCenter.width - elementCenter.x));

  //根据角度和距离计算 x 和 y 平移
  const translateX = Math.abs(Math.cos(angle) * offsetDistance);
  const translateY = Math.abs(Math.sin(angle) * offsetDistance);

  //计算距中心（视口对角线）的最大可能距离
  const maxDistance = Math.sqrt(Math.pow(viewportCenter.width, 2) + Math.pow(viewportCenter.height, 2));

  //计算当前距离中心的距离
  const currentDistance = Math.sqrt(Math.pow(viewportCenter.width - elementCenter.x, 2) + Math.pow(viewportCenter.height - elementCenter.y, 2));

  //根据距中心的距离缩放旋转和平移（较近的元素旋转/平移较少，较远的元素旋转/平移较多）
  const distanceFactor = currentDistance / maxDistance;

  //根据相对于中心的位置计算旋转值
  const rotationX = ((elementCenter.y < viewportCenter.height ? -1 : 1) * (translateY / offsetDistance) * maxRotation * distanceFactor);
  const rotationY = ((elementCenter.x < viewportCenter.width ? 1 : -1) * (translateX / offsetDistance) * maxRotation * distanceFactor);

  //根据距中心的距离计算Z轴平移（深度）
  const translateZ = maxZTranslation * distanceFactor;

  //根据相对于视口中心的位置确定方向
  return {
    x: elementCenter.x < viewportCenter.width ? -translateX : translateX,
    y: elementCenter.y < viewportCenter.height ? -translateY : translateY,
    z: translateZ,
    rotateX: rotationX,
    rotateY: rotationY
  };
};
